// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  ShoppingCart,
  PayType,
  PayWithCode,
  PaySuccess,
} from './';

export default {
  path: 'pay',
  name: 'Pay',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: '/cart', name: 'Shopping cart', component: ShoppingCart },
    { path: '/paytype/:id', name: 'Pay type', component: PayType },
    { path: '/payWithCode/:id/:id', name: 'Pay with code', component: PayWithCode },
    { path: '/paysuccess/:id/:id', name: 'Pay success', component: PaySuccess },
  ],
};



// WEBPACK FOOTER //
// ./src/features/pay/route.js